'use strict';

angular.module('app.entity.audit').component('historyFieldFileValue', {
    templateUrl: 'modules/ecrd/components/audit/components/history-field-file-value.template.html',
    bindings: {
        value: '<',
    },
    controller: [function() {
        var vm = this;
    }],
});
